document.addEventListener('alpine:init', () => {
  Alpine.data('ProductBisModal', () => ({
    show: false,

    state: 'idle',

    init() {
      this.$root
        .closest('product-form')
        .addEventListener('change', this.watchProductFormChange.bind(this))

      this.$watch('show', this.onShowUpdate.bind(this))
    },

    watchProductFormChange(e) {
      const productForm = this.$root.closest('product-form')
      const variantId = productForm.querySelector('[name="id"]').value
      this.$refs.variantInput.value = variantId
    },

    onShowUpdate(val) {
      if(!val) {
        this.state = 'idle'
        this.$refs.bisForm.reset()
      }
    },

    async handleSubmit(e) {
      const formData = new FormData(e.target)
      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2024-06-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: formData.get('email'),
                  }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${formData.get('variant')}`
                }
              }
            }
          }
        })
      };

      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${formData.get('a')}`, options)
        .then(response => {
          if (!response.ok || !response.status === 202) this.state = 'error'
          this.state = 'success'
        })
    },
  }))
})
